package one.healthium.login.ui.silentLogin

import one.healthium.domain.user.UserModel

data class SilentLoginUiState(
    val user: UserModel? = null,
    val error: Throwable? = null,
)
